const buildApiBaseUrl = () => {
  const rawUrl = process.env.REACT_APP_CARDS_API_URL || "";
  if (!rawUrl) return "";
  return rawUrl.startsWith("http") ? rawUrl : `https://${rawUrl}`;
};

const apiBaseUrl = buildApiBaseUrl();

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
});

const parseJsonOrThrow = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(
      data.message || `Richiesta fallita (${response.status}).`,
    );
    error.statusCode = response.status;
    error.payload = data;
    throw error;
  }
  return data;
};

export const fetchCreditPacks = async ({ token }) => {
  const res = await fetch(`${apiBaseUrl}/self/billing/credit-packs`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseJsonOrThrow(res);
};

export const lookupVat = async ({ token, vat }) => {
  const res = await fetch(
    `${apiBaseUrl}/self/billing/vat-lookup?vat=${encodeURIComponent(vat)}`,
    {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return parseJsonOrThrow(res);
};

export const createCreditsCheckout = async ({
  token,
  packId,
  billingOverride,
  saveToCard,
  mode,
}) => {
  const res = await fetch(`${apiBaseUrl}/self/billing/credits-checkout`, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({
      packId,
      billingOverride,
      saveToCard: Boolean(saveToCard),
      ...(mode ? { mode } : {}),
    }),
  });
  return parseJsonOrThrow(res);
};
